import "../../utils/tailwind.css";
import { PageProvider, usePageProvider } from "./provider";
import Section from "../../components/section";
import { Accordion } from "react-bootstrap";
import { Formik, Form, FieldArray } from "formik";
import { FormikInput } from "../../components/input";
import Plus from "../../components/svg/plus";
import Label from "../../components/label";
import Trash from "../../components/svg/trash";
import Button from "../../components/Buttons";
import { FormikTextarea } from "../../components/textarea";
import { FormikDropdown } from "../../components/dropdown";

export default function AddUser() {
  return (
    <div className="p-3 bg-[#fffbf4] ">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit, monialsRef, getFaqQuery, } = usePageProvider();

  return (
    <Section>
      <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
        {({ values, setFieldValue }) => (
          <Form>
            <Accordion defaultActiveKey="0" className="mt-5">
              <Accordion.Item eventKey="30" className="w-[100%]  ml-[1rem] ">
                <Accordion.Header>SEO META</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div className="flex flex-col">
                      <Label label="Meta Title" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_title" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="Meta Keywords" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_keyword" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col ">
                      <Label label="Meta Description" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_desc" rootClassName="w-full" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2" className="w-[100%] ml-[1rem]">
                <Accordion.Header>Banner</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label label="Primary Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.primary_heading" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="Secondery Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.secondary_heading" rootClassName="w-full" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-4 gap-3 mt-3 ">
                    <div className="flex flex-col">
                      <Label label="CTA Label" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.primary_cta.label" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="CTA Redirect Link" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.primary_cta.redirect_link" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="Secondery CTA Label" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.secondary_cta.label" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="Secondery CTA Redirect Link" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.secondary_cta.redirect_link" rootClassName="w-full" />
                    </div>
                  </div>

                  <div className="flex flex-col mt-2">
                    <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                    <FormikTextarea name="header.description" rootClassName="w-full" />
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="6" className="w-[100%] ml-[1rem] mb-8">
                <Accordion.Header>FAQ's</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-1 gap-3">
                    <div className="flex flex-col">
                      <Label label="FAQ Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="testimonials.heading" rootClassName="w-full" />
                    </div>
                  </div>
                  <div className="flex justify-end mb-2 mt-3">
                    <div className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer" onClick={() => monialsRef?.current?.push({ faq: "" })}>
                      <Plus className="text-white" />
                    </div>
                  </div>

                  <FieldArray name="testimonials.testimonials">
                    {(arrayHelpers) => {
                      monialsRef.current = arrayHelpers;

                      return (
                        <div className="mt-2 overflow-x-auto">
                          <table className="w-full table-fixed border-collapse border border-gray-300">
                            <thead className="bg-gray-200">
                              <tr>
                                <th className="w-[94%] border font-normal border-gray-300 px-2 py-2 text-left">Faq</th>
                                <th className="w-[6%] border font-normal border-gray-300 px-2 py-2 text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {values?.testimonials?.testimonials?.map((item, index) => (
                                <tr key={index}>
                                  <td className="border border-gray-300 px-4 py-2">
                                    <FormikDropdown
                                      options={getFaqQuery?.data?.data?.data?.map((item) => ({
                                        label: item.ques,
                                        value: item.id,
                                      }))}
                                      name={`testimonials.testimonials.${index}.faq`}
                                      rootClassName="w-full"
                                    />
                                  </td>
                                  <td className="border border-gray-300 px-4 py-2 text-center">
                                    <div className="flex justify-center cursor-pointer" onClick={() => monialsRef?.current?.remove(index)}>
                                      <Trash />
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      );
                    }}
                  </FieldArray>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <div className="fixed bottom-0 z-[999] left-0 w-full bg-[#fef5e4] flex justify-end items-center py-3 rounded-lg pr-4 space-x-3 shadow-md">
              <Button
                type="submit"
                className="!border-none text-white rounded-md !bg-[#7C13CA] hover:!bg-[#ffd869] hover:!text-black transition-colors duration-200"
              >
                Save
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
